// extracted by mini-css-extract-plugin
export default {"navBar":"Nav_navBar__JbeGm","iconBox":"Nav_iconBox__dn5of"};